module.exports = __webpack_public_path__ + "static/img/3.1e1fa7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fgimg/3.jpg
// module id = 2BmB
// module chunks = 18